import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import { Shield, Globe, Lock } from 'lucide-react';
import Button from '../../common/Button';

const NetworkSolution = () => {
  const { t } = useTranslatedContent('infrastructure');

  const features = {
    firewall: {
      title: t('solutions.network.features.firewall.title'),
      items: t('solutions.network.features.firewall.items', { returnObjects: true })
    },
    routing: {
      title: t('solutions.network.features.routing.title'),
      items: t('solutions.network.features.routing.items', { returnObjects: true })
    },
    vpn: {
      title: t('solutions.network.features.vpn.title'),
      items: t('solutions.network.features.vpn.items', { returnObjects: true })
    }
  };

  const renderFeatureList = (items: any) => {
    if (!Array.isArray(items)) return null;
    return items.map((item, index) => (
      <li key={index} className="flex items-start">
        <span className="mr-2">•</span>
        {item}
      </li>
    ));
  };

  return (
    <div className="bg-gradient-to-br from-orange-900 to-red-900 rounded-3xl p-8 lg:p-12 text-white">
      <div className="text-center mb-12">
        <h3 className="text-2xl font-semibold">{t('solutions.network.title')}</h3>
        <p className="mt-4 text-orange-100">{t('solutions.network.description')}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Shield className="h-8 w-8 text-orange-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.firewall.title}</h4>
          <ul className="space-y-2 text-orange-100">
            {renderFeatureList(features.firewall.items)}
          </ul>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Globe className="h-8 w-8 text-orange-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.routing.title}</h4>
          <ul className="space-y-2 text-orange-100">
            {renderFeatureList(features.routing.items)}
          </ul>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Lock className="h-8 w-8 text-orange-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.vpn.title}</h4>
          <ul className="space-y-2 text-orange-100">
            {renderFeatureList(features.vpn.items)}
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Button
          variant="secondary"
          className="bg-white text-orange-900 hover:bg-orange-50"
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
        >
          {t('solutions.network.cta')}
        </Button>
      </div>
    </div>
  );
};

export default NetworkSolution;